<template>
  <div :class="$style.badge">
    {{ t('label') }}
  </div>
</template>

<i18n>
{
  "ru": {
    "label": "Уже есть"
  }
}
</i18n>

<script setup lang="ts">
defineOptions({
  name: 'FantasyCommonSetCardOwnedBadge'
})

const { t } = useI18n()
</script>

<style lang="scss" module>
.badge {
  @include typo-get(subhead-xs);
  padding: 0.2em 0.4em;
  border-radius: 0.4em;
  background: color-get(--root-rgb-accent-2);
  color: color-get(--root-rgb-text-inverse);
  white-space: nowrap;
}
</style>
